import { Routes, Route } from 'react-router-dom';
import Login from '../pages/admin/Login';
import Home from '../pages/admin/Home';
import Users from '../pages/admin/Users';
import Transactions from '../pages/admin/Transactions';
import TransactionApprovals from '../pages/admin/TransactionApprovals';
import CodeGraph from '../pages/admin/CodeGraph';
import NotFound from '../pages/admin/NotFound';
import ProtectedRoute from './ProtectedRoutes';
import PageWrapper from '../components/PageWrapper';

const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<PageWrapper title="Login"><Login /></PageWrapper>} />
      <Route element={<ProtectedRoute />}>
        <Route path="/" element={<PageWrapper title="Dashboard"><Home /></PageWrapper>} />
        <Route path="/users" element={<PageWrapper title="Users"><Users /></PageWrapper>} />
        <Route path="/transactions" element={<PageWrapper title="Transactions"><Transactions /></PageWrapper>} />
        <Route path="/transaction-approvals" element={<PageWrapper title="Transaction Approvals"><TransactionApprovals /></PageWrapper>} />
        <Route path="/code-graph" element={<PageWrapper title="Code Graph"><CodeGraph /></PageWrapper>} />
        <Route path="*" element={<PageWrapper title="Not Found"><NotFound /></PageWrapper>} />
      </Route>
    </Routes>
  );
};

export default AdminRoutes;
